import React from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from 'ckeditor5-build/build/ckeditor';
import { uploadPlugin } from './ImageUploader';

interface EditorProps {
  value: string;
  onChange?: (event: string) => void;
  placeholder?: string;
  disabled?: boolean;
  minHeight?: number;
  height?: number;
  /**
   * @description Editor 데이터 읽기용
   */
  className?: string;
}

function Editor({
  value,
  onChange,
  placeholder,
  minHeight = 200,
  height,
  disabled,
  className,
}: EditorProps) {
  const editorConfig = {
    extraPlugins: [uploadPlugin],
    alignment: {
      options: ['left', 'center', 'right'],
    },
    image: {
      resizeOptions: [
        {
          name: 'resizeImage:original',
          label: 'Original',
          value: null,
        },
        {
          name: 'resizeImage:100',
          label: '10%',
          value: '10',
        },
        {
          name: 'resizeImage:100',
          label: '20%',
          value: '20',
        },
        {
          name: 'resizeImage:100',
          label: '30%',
          value: '30',
        },
        {
          name: 'resizeImage:100',
          label: '40%',
          value: '40',
        },
        {
          name: 'resizeImage:100',
          label: '50%',
          value: '50',
        },
        {
          name: 'resizeImage:100',
          label: '60%',
          value: '60',
        },
        {
          name: 'resizeImage:100',
          label: '70%',
          value: '70',
        },
        {
          name: 'resizeImage:100',
          label: '80%',
          value: '80',
        },
        {
          name: 'resizeImage:100',
          label: '90%',
          value: '90',
        },
        {
          name: 'resizeImage:100',
          label: '100%',
          value: '100',
        },
      ],
      toolbar: [
        'resizeImage',
        '|',
        'imageStyle:wrapText',
        'imageStyle:breakText',
        '|',
        'toggleImageCaption',
        'imageTextAlternative',
      ],
    },
    htmlSupport: {
      allow: [
        {
          name: /.*/,
          attributes: false,
          classes: true,
          styles: false,
        },
      ],
    },
    fontFamily: {
      options: [
        'default',
        'SUITE',
        'Arial',
        '궁서체, Noto Serif KR, serif',
        '바탕, Malgun Gothic, Noto Sans KR, sans-serif',
        'Pretendard',
      ],
      supportAllValues: true,
    },
    mediaEmbed: {
      previewsInData: true,
    },
    fontSize: {
      options: [9, 11, 13, 15, 17, 19, 21, 22, 24, 28, 32],
      supportAllValues: true,
    },
    heading: {
      options: [
        {
          model: 'paragraph1',
          view: {
            name: 'p',
            classes: 'heading_paragraph1',
          },
          title: '문단 1',
          class: 'ck-heading_paragraph1',
        },
        {
          model: 'paragraph2',
          view: {
            name: 'p',
            classes: 'heading_paragraph2',
          },
          title: '문단 2',
          class: 'ck-heading_paragraph2',
        },
        {
          model: 'paragraph3',
          view: {
            name: 'p',
            classes: 'heading_paragraph3',
          },
          title: '문단 3',
          class: 'ck-heading_paragraph3',
        },
        {
          model: 'paragraph',
          title: '권장 본문',
          class: 'ck-heading_paragraph',
        },
        {
          model: 'heading1',
          view: 'h1',
          title: '권장 제목',
          class: 'ck-heading_heading1',
        },
        {
          model: 'heading2',
          view: 'h2',
          title: 'Heading 2',
          class: 'ck-heading_heading2',
        },
        {
          model: 'heading3',
          view: 'h3',
          title: 'Heading 3',
          class: 'ck-heading_heading3',
        },
      ],
    },
    toolbar: {
      items: [
        'heading',
        '|',
        'fontSize',
        'bold',
        'italic',
        'underline',
        'strikethrough',
        'fontColor',
        'fontBackgroundColor',
        'fontFamily',
        'lineHeight',
        'alignment',
        '|',
        'link',
        'bulletedList',
        'numberedList',
        'horizontalLine',
        'specialCharacters',
        '|',
        'outdent',
        'indent',
        '|',
        'imageUpload',
        'blockQuote',
        'insertTable',
        'mediaEmbed',
        'undo',
        'redo',
        '|',
        'sourceEditing',
      ],
      shouldNotGroupWhenFull: true,
    },

    placeholder: placeholder || 'placeholder',
  };

  return (
    <article
      style={
        {
          '--ck-editor-min-height': `${minHeight}px`,
          '--ck-editor-height': `${height}px`,
        } as React.CSSProperties
      }
      className={className}
    >
      <CKEditor
        editor={ClassicEditor as any}
        config={editorConfig as any}
        data={value}
        disabled={disabled}
        onChange={(_event, editor) => {
          onChange && onChange(editor.data.get());
        }}
      />
    </article>
  );
}

export default Editor;
